const RO_SUGGESTION_ACCEPTED = 'SA_ro_suggestion_accepted';
const RO_SUGGESTION_DISMISSED = 'SA_ro_suggestion_dismissed';
const RO_CREATED_FROM_SUGGESTION = 'SA_ro_created_from_suggestion';

const salesIntelligence = {
  recurringOrderSuggestionAccepted: (suggestion) => ({
    eventName: RO_SUGGESTION_ACCEPTED,
    eventData: {
      id: suggestion.id,
      addressFrom: suggestion.addressFrom,
      addressTo: suggestion.addressTo,
      user: suggestion.user,
    },
  }),

  recurringOrderSuggestionDismissed: (suggestion) => ({
    eventName: RO_SUGGESTION_DISMISSED,
    eventData: {
      id: suggestion.id,
      reason: suggestion.reason,
      addressFrom: suggestion.addressFrom,
      addressTo: suggestion.addressTo,
      user: suggestion.user,
    },
  }),

  recurringOrderCreatedFromSuggestion: (suggestion, recurringOrder) => ({
    eventName: RO_CREATED_FROM_SUGGESTION,
    eventData: {
      id: suggestion.id,
      addressFrom: suggestion.addressFrom,
      addressTo: suggestion.addressTo,
      user: suggestion.user,
      recurringOrder,
    },
  }),
};

export default salesIntelligence;
